import { FormikHelpers } from 'formik'
import * as React from 'react'
import { ITheme } from 'stores/Theme.types'

import { HandbookType, HandbookV2 } from 'types'

export interface HandbookSettingsProps {
  onClose: (backToTemplates?: boolean) => void
  initialTab?: SettingsTab
}

export interface NavigationProps {
  activeTab: SettingsTab
  handleNavItemClick: (tab: SettingsTab) => void
  handbookType?: HandbookType
  handbook: HandbookV2
  skip?: SettingsTab[]
}

interface HandbookV2UpdatePayload extends Omit<HandbookV2, 'theme'> {
  theme_hue: ITheme['hue']
  theme_preset: ITheme['preset']
  theme_overrides: ITheme['overrides']
}

export interface BaseSectionProps {
  handbook: HandbookV2
  onUpdate: (values: Partial<HandbookV2UpdatePayload>, formikHelpers?: FormikHelpers<HandbookV2>) => Promise<void>
  isUpdating: boolean
}

export interface DocumentationSettingsProps extends BaseSectionProps {
  selectName?: boolean
}

export interface PreferencesProps extends BaseSectionProps {}

export interface PublishProps {
  handbook: HandbookV2
}

export interface DeleteHandbookProps {
  handbook: HandbookV2
}
export interface SettingsSectionProps {
  children: React.ReactNode
  onIntersect: () => void
  tab: SettingsTab
  isFirst?: boolean
  parentRef: any
}

export enum SettingsTab {
  Documentation = 'documentation',
  Sidebar = 'sidebar',
  CustomUrl = 'custom url',
  Publish = 'publish',
  Workflow = 'statuses',
  Delete = 'delete',
}
